<script setup lang="ts">

import ColoredNumber from '@/components/Elements/Generic/ColoredNumber.vue'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'

/**
 * Props
 */
defineProps({
  type: {
    type: String,
    required: true
  },
  amount: {
    type: Number,
    required: true
  }
});

</script>

<template>
<div class="rounded bg-metal-900 p-1 px-2 flex">
  <GenericIcon :type="type"/><ColoredNumber :amount="amount" class="ps-2 pt-0.5"/>
</div>
</template>

<style scoped lang="scss">

</style>